export default __webpack_public_path__ + "static/media/login_logo1.61929a8d.png";